'use client';

import { useEffect } from 'react';
import ErrorComponent from '@molecules/ErrorComponent/ErrorComponent';

/**
 * App Router Error page
 * Catches runtime errors in route segments and their nested children
 * Automatically wraps route segment in React Error Boundary
 */
export default function Error({ error, reset: _reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    if (typeof window.newrelic !== 'undefined') {
      const { newrelic } = window;
      newrelic.noticeError(error);
    }
    console.error('App Router Error:', error);
  }, [error]);

  return <ErrorComponent errorCode={500} />;
}
